'use client'

import { useEffect } from 'react'
import { useSearchParams } from 'next/navigation'
import { InfoAlert } from '@/General/InfoAlert'

export const CommunitySuccessHandler = () => {
  const searchParams = useSearchParams()
  const showQuestionSuccess = searchParams.get('questionPosted') === 'true'
  const showAnswerSuccess = searchParams.get('answerPosted') === 'true'

  useEffect(() => {
    if (showQuestionSuccess || showAnswerSuccess) {
      // Small delay to ensure the element is rendered
      setTimeout(() => {
        const element = document.getElementById('community-success-message')
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          })
        }
      }, 100)
    }
  }, [showQuestionSuccess, showAnswerSuccess])

  if (showQuestionSuccess) {
    return (
      <div id="community-success-message">
        <InfoAlert
          variant="success"
          title="Question posted successfully!"
          className="mb-4"
        >
          Your question has been posted and is now visible to the community.
          Other magicians will be able to help answer it.
        </InfoAlert>
      </div>
    )
  }

  if (showAnswerSuccess) {
    return (
      <div id="community-success-message">
        <InfoAlert
          variant="success"
          title="Answer posted successfully!"
          className="mb-4"
        >
          Thank you for helping out a fellow magician! Your answer has been
          posted and is now visible to the community.
        </InfoAlert>
      </div>
    )
  }

  return null
}
